import { useEffect, useState } from "react";
import { IResponseApiFluent, codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { IPanelEditarIncidente } from "../editarIncidente/PanelEditarIncidente";
import { IIncidenteOculto } from "../../../../../Interfaces/hazard/IHazard";
import { GrupoIncidenteService } from "../../../../../services/hazard/grupoIncidente";

export const UsePanelOcultoIncidente=(props:IPanelEditarIncidente)=>{
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const initial:IIncidenteOculto={
        esOculto: false,
        grupoIncidenteId: "",
    }
    const [request,setRequest]=useState<IIncidenteOculto>(initial)
    const reset=()=>{
        setMensaje("")
        setRequest(initial)
        setStatus(0)
        props.onDismiss()
    }
    useEffect(()=>{
        if(props.isOpen){
          setRequest({...request,esOculto:props.item.esOculto,grupoIncidenteId:props.item.grupoIncidenteId})
          }
    },[props.isOpen])
    const putEditarCatalogo=()=>{
        setLoading(true)
        GrupoIncidenteService.OcultoIncidente(request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(()=>{
                    props.reload?.();
                    reset()
                },3000)
            }else{
                setStatus(500)
            }
            setLoading(false)
           
        }).catch((e)=>{
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
              ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);
              } else {
                console.log('Error detallado:', e);
                setMensaje("Error Inesperado");
              }
              setStatus(500);
              setLoading(false);
        })
    }
    return {request,setRequest,putEditarCatalogo,loading,reset,mensaje,status}
}